/** Offset from the cursor so the chip does not sit under the pointer. */
export const FILTER_HOVER_CHIP_OFFSET_PX = 12;
/** Gap from the viewport edges. */
export const FILTER_HOVER_CHIP_MARGIN_PX = 12;
/** Slim chip width cap; long copy wraps instead of overflowing. */
export const FILTER_HOVER_CHIP_MAX_WIDTH_PX = 240;
/** Fallback height before the chip is measured (one or two lines). */
export const FILTER_HOVER_CHIP_ESTIMATED_HEIGHT_PX = 40;

export const FILTER_HOVER_CHIP_MAX_WIDTH_SX = `min(${FILTER_HOVER_CHIP_MAX_WIDTH_PX}px, calc(100vw - ${FILTER_HOVER_CHIP_MARGIN_PX * 2}px))`;

/**
 * Rendered hover-chip box from layout. Omit to use max-width / estimated height.
 */
export type FilterHoverChipSize = {
  /** Rendered width in px; short labels are narrower than the max. */
  width?: number;
  /** Rendered height in px after wrap. */
  height?: number;
};

function clampAxis(mouse: number, viewportSize: number, estimatedSize: number): number {
  const maxStart = Math.max(
    FILTER_HOVER_CHIP_MARGIN_PX,
    viewportSize - estimatedSize - FILTER_HOVER_CHIP_MARGIN_PX
  );
  return Math.min(
    Math.max(FILTER_HOVER_CHIP_MARGIN_PX, mouse + FILTER_HOVER_CHIP_OFFSET_PX),
    maxStart
  );
}

function resolveChipWidth(maxWidth: number, measuredWidth: number | undefined): number {
  if (measuredWidth != null && measuredWidth > 0) {
    return Math.min(measuredWidth, maxWidth);
  }
  return maxWidth;
}

export function clampFilterHoverChipPosition(
  mouseX: number,
  mouseY: number,
  viewportWidth: number,
  viewportHeight: number,
  chipSize?: FilterHoverChipSize
): { left: number; top: number } {
  const maxWidth = Math.min(
    FILTER_HOVER_CHIP_MAX_WIDTH_PX,
    Math.max(0, viewportWidth - FILTER_HOVER_CHIP_MARGIN_PX * 2)
  );
  const chipHeight =
    chipSize?.height != null && chipSize.height > 0
      ? chipSize.height
      : FILTER_HOVER_CHIP_ESTIMATED_HEIGHT_PX;

  return {
    left: clampAxis(mouseX, viewportWidth, resolveChipWidth(maxWidth, chipSize?.width)),
    top: clampAxis(mouseY, viewportHeight, chipHeight)
  };
}
